import { render } from "./Menu.vue?vue&type=template&id=2aeafff5&scoped=true&ts=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"

import "./Menu.vue?vue&type=style&index=0&id=2aeafff5&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aeafff5"]])

export default __exports__